var _style, _circle, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNotice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-alert",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#A7ABC3;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st1{fill:none;stroke:#A7ABC3;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_6",
    className: "st0",
    cx: 11,
    cy: 11,
    r: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_2",
    className: "st1",
    x1: 11,
    y1: 7,
    x2: 11,
    y2: 11
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_3",
    className: "st1",
    x1: 11,
    y1: 15,
    x2: 11,
    y2: 15
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotice);
export default __webpack_public_path__ + "static/media/icon-notice.074da29d908a4bc2cf0d4ff615df35db.svg";
export { ForwardRef as ReactComponent };